var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',{scopedSlots:_vm._u([{key:"insideContent",fn:function(){return [_c('v-container',{attrs:{"fluid":""}},[_c('Alert'),_c('Overview'),_c('e-chart-credit')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }